<template>
  <div>
    <!-- Button -->
    <ib-button
      class="px-2 px-lg-3"
      variant="white"
      font-family="regular"
      :disabled="disabled"
      @click="onClick"
    >
      {{ $t('pages.businessGuide.profitAndCashFlow.addDialog.fields.incomeTaxes.navigation') }}
    </ib-button>
    <!-- /Button -->
    <!-- Dialog Set Income Taxes -->
    <dialog-set-income-taxes
      :dialog-set-income-taxes-visible="dialogVisible"
      @close-dialog-set-income-taxes="onCloseDialog"
      @on-update-profit-and-cash-flow-view="getProfitAndCashFlow"
    />
    <!-- /Dialog Set Income Taxes -->
  </div>
</template>

<script>
import DialogSetIncomeTaxes from '@/views/Home/StoryMode/Forecast/ProfitAndCashFlow/Dialogs/DialogSetIncomeTaxes'
import MixinApiCalculations from '@/mixins/apiCalculations'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'

export default {
  name: 'SetIncomeTaxes',

  components: {
    DialogSetIncomeTaxes
  },

  mixins: [MixinApiCalculations, MixinIdeaRoles],

  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      dialogVisible: false
    }
  },

  methods: {
    onClick () {
      if (!this.canEdit) return
      this.dialogVisible = true
    },

    onCloseDialog () {
      this.dialogVisible = false
    }
  }
}
</script>
